
import { MetalAreaChart, ChartLoadingState } from "@/components/charts";
import { TimePeriod } from "@/lib/metal-price";

interface PriceChartContentProps {
  isLoading: boolean;
  error: { hasError: boolean; message?: string };
  noData?: boolean;
  chartData: any[];
  selectedTimePeriod: TimePeriod;
  onRetry: () => void;
  getPeriodText: (period: TimePeriod) => string;
  isSearchingAlternative?: boolean;
}

export function PriceChartContent({
  isLoading,
  error,
  noData = false,
  chartData,
  selectedTimePeriod,
  onRetry,
  getPeriodText,
  isSearchingAlternative = false
}: PriceChartContentProps) {
  if (isLoading) {
    return <ChartLoadingState isSearchingAlternative={isSearchingAlternative} period={getPeriodText(selectedTimePeriod)} />;
  }
  
  if (error.hasError) {
    return (
      <ChartLoadingState 
        error={true} 
        errorMessage={error.message}
        onRetry={onRetry}
      />
    );
  }
  
  if (noData || chartData.length === 0) {
    return (
      <ChartLoadingState 
        noData={true} 
        period={getPeriodText(selectedTimePeriod)}
        onRetry={onRetry}
      />
    );
  }
  
  return (
    <MetalAreaChart 
      chartData={chartData} 
      selectedTimePeriod={selectedTimePeriod} 
    />
  );
}
